// TODO: Handle server errors. Now user can't proceed if server responded with
// error

import React from 'react'
import { useFormContext } from 'react-hook-form'

import { Lang } from '../../types/common-types'
import { State } from '../../state-actions-reducers'
import AccountForm from '../../types/account-form.types'
import ProductsInput from '../../shared/Inputs/ProductsInput/ProductsInput'
import styles from './ScreenThree.module.scss'

interface Props {
  lang: Lang
  accountForm: AccountForm
}

/* THE COMPONENT */
function ScreenThree({
  lang,
  accountForm,
}: Props) {
  const { watch, setValue } = useFormContext<State>()
  const state = watch()

  return (
    <>
      <main className={styles.main}>
        <div className="form-group">
          <div className="row">
            <div className="col-12 col-xs-12">
              <h3>{accountForm.stepThreeHeader[lang]}</h3>
              <p>{accountForm.stepThreeHeaderDesc[lang]}</p>
            </div>
          </div>
          <ProductsInput
            lang={lang}
            accountForm={accountForm}
            initialValue={state.goods}
            onChange={data => {
              setValue('goods', data as any, { shouldDirty: true })
            }}
            valid={true}
            required
          />
        </div>
      </main>
    </>
  )
}

export default ScreenThree
